export function createErp() {
  return {
    ErpId: '',
    Nombre: ''
  };
}
